import { makeStyles } from '@material-ui/core/styles'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import {
    AtlasWhite_100,
    ColorBaseMulberryBlue,
    ColorBaseWhite,
    ColorEastBay,
    FontWeightLightBold
} from 'assets/styles/variables'
import { atlasFontFamily } from 'components/atlas-components/typography'

const drawerWidth = 658

export const TEMPLATE_HEADER_LINK = styled('a')`
    color: var(--Semantic-Color-Link-Default, #385f99);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: 'Source Sans Pro';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    text-decoration: none;
    cursor: pointer;
`

export const useStyles = makeStyles((theme) => ({
    drawer: {
        width: drawerWidth,
        [theme.breakpoints.down('md')]: {
            width: '100vw'
        }
    },
    templateDownloadLink: {
        color: ColorEastBay,
        textDecoration: 'none',
        fontWeight: 600,
        '&:hover': {
            textDecoration: 'underline'
        }
    },
    drawerPaper: {
        position: 'fixed',
        width: drawerWidth,
        [theme.breakpoints.down('md')]: {
            width: '100vw'
        }
    },
    headerTitle: {
        fontWeight: 600,
        fontSize: '22px',
        padding: '16px',
        lineHeight: '26px'
    },
    contentBox: {
        display: 'flex',
        padding: '0 24px 24px 24px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '40px',
        flex: '1 0 0',
        alignSelf: 'stretch'
    },
    defaultTemplateSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px',
        alignSelf: 'stretch'
    },
    root: {
        padding: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 12,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        gap: '16px'
    },
    rootContainer: {
        borderRadius: 12,
        backgroundColor: AtlasWhite_100,
        width: '100%'
    },
    iconBox: {
        display: 'flex',
        alignItems: 'center'
    },
    logo: {
        width: 36,
        height: 36,
        borderRadius: 8,
        display: 'inline-block',
        marginRight: theme.spacing(2)
    },
    textBox: {
        display: 'flex',
        flexDirection: 'column'
    },
    title: {
        fontWeight: 600,
        fontSize: '16px',
        color: '#2e3b55'
    },
    // subtitle: {
    //     color: AtlasGreyDark,
    //     fontSize: '16px',
    //     fontWeight: 400
    // },
    rightSection: {
        display: 'flex',
        alignItems: 'center'
    },
    downloadButton: {
        fontSize: '14px',
        color: '#455D82',
        lineHeight: '18px',
        fontWeight: 600,
        marginRight: theme.spacing(2),
        textTransform: 'none',
        '&:focus': {
            border: `2px solid ${ColorBaseMulberryBlue}`,
            padding: '5px',
            borderRadius: '40px'
        }
    },
    myIconButton: {
        marginLeft: 'auto',
        '&:focus': {
            border: `2px solid ${ColorBaseMulberryBlue}`,
            padding: '5px',
            borderRadius: '40px',
            height: '35px',
            width: '35px'
        }
    },
    uploadSection: {
        width: '100%'
    },
    uploadStatus: {
        marginTop: '16px'
    },
    templateTitle: {
        color: 'var(--Semantic-Color-Type-Default, #1E1E1E)',
        fontFeatureSettings: "'liga' off, 'clig' off",
        fontfamily: 'Source Sans Pro',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '18px',
        marginBottom: '8px'
    },
    // templateUploadTitle: {
    //     fontSize: '16px',
    //     fontStyle: 'normal',
    //     marginTop: '24px',
    //     fontWeight: 600,
    //     lineHeight: '20px'
    // },
    // templateUploadSubtitle: {
    //     color: 'var(--Semantic-Color-Type-Muted, #676767)',
    //     fontSize: '14px',
    //     lineHeight: '18px',
    //     marginBottom: '8px'
    // },
    // templateLearnMore: {
    //     color: 'var(--Semantic-Color-Link-Default, #385F99)',
    //     fontFeatureSettings: "'liga' off, 'clig' off",
    //     fontFamily: '"Source Sans Pro"',
    //     fontSize: '14px',
    //     fontStyle: 'normal',
    //     fontWeight: 400,
    //     lineHeight: '18px'
    // },
    footerSection: {
        marginTop: 'auto'
    },
    footer: {
        height: '72px',
        backgroundColor: '#fff',
        zIndex: theme.zIndex.drawer + 1,
        flexShrink: 0
    },
    footerComp: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        padding: theme.spacing(2),
        gap: '16px'
    },
    saveTemplate: {
        textTransform: 'none',
        backgroundColor: ColorEastBay,
        display: 'flex',
        color: '#fff',
        borderWidth: '0px',
        borderRadius: '3px',
        letterSpacing: '0.5px',
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        padding: '8px 12px',
        fontWeight: 600,
        placeContent: 'center',
        gap: '8px',
        '&:focus, &:active': {
            outline: 'none',
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`,
            borderRadius: '2px',
            backgroundColor: `${ColorEastBay}`
        },
        '&:hover': {
            backgroundColor: '#364262',
            color: '#fff',
            cursor: 'pointer'
        }
    },
    headerBox: {
        height: '64px',
        backgroundColor: '#fff',
        zIndex: theme.zIndex.drawer + 1,
        flexShrink: 0,
        display: 'flex'
    },
    btnContainer: {
        float: 'right',
        display: 'flex',
        alignItems: 'center',
        margin: 'auto',
        marginRight: '16px',
        textDecoration: 'none'
    },
    body: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    closeButton: {
        '&:focus, &:active': {
            padding: '2px',
            margin: '2px',
            outline: `2px solid ${ColorBaseMulberryBlue}`
        }
    },
    templateDetails: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '40px 0px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        [theme.breakpoints.down('sm')]: {
            padding: '16px'
        }
    },
    label: {
        marginBottom: '4px',
        color: 'var(--ColorBaseRichBlack, #1E1E1E)',
        fontFamily: 'Source Sans Pro',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '16px'
    },
    textField: {
        width: '100%',
        marginTop: 0,
        '& .MuiOutlinedInput-root': {
            marginTop: 0
        },
        '& textarea': {
            textIndent: 0
        },
        '& p': {
            marginLeft: 0
        }
    },
    fieldWrapper: {
        position: 'relative',
        width: '100%'
    },
    btnClass: {
        padding: '8px 12px 8px 12px'
    },
    templateInfoContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2)
    },
    templateInfoBox: {
        display: 'flex',
        flexDirection: 'column'
    },
    templateInfoTitle: {
        fontWeight: 700,
        marginBottom: theme.spacing(1),
        fontSize: '13px',
        lineHeight: '18px'
    },
    templateInfoText: {
        marginBottom: theme.spacing(0.25),
        fontWeight: 400,
        fontSize: '13px'
    },
    description: {
        color: 'var(--Semantic-Color-Type-Muted, #676767)',
        fontFeatureSettings: "'liga' off, 'clig' off",
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '20px'
    },
    inputLabel: {
        marginBottom: '-16px',
        color: 'var(--ColorBaseRichBlack, #1E1E1E)',
        fontFamily: 'Source Sans Pro',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '16px'
    },
    errorRow: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '8px',
        justifyContent: 'space-between'
    },
    errorIconBox: {
        display: 'flex',
        alignItems: 'center',
        margin: '0 8px',
        marginTop: '8px'
    },
    errorList: {
        margin: '8px 10px 10px 26px'
    }
}))

export const DeleteButton = css`
    background-color: #af292e;
    height: 40px;
    color: ${ColorBaseWhite};
    font-family: ${atlasFontFamily};
    font-style: normal;
    font-weight: ${FontWeightLightBold};
    font-size: 16px;
    border: none;
    mix-blend-mode: normal;
    border-radius: 2px;
    margin-right: auto;
    text-align: center;
    &:focus {
        outline: none;
        box-shadow: 0 0 0 1px ${ColorBaseWhite}, 0 0 0 3px ${ColorBaseMulberryBlue};
        border-radius: 2px;
    }
    &:hover {
        background-color: rgb(131, 20, 24);
        color: #fff;
        cursor: pointer;
    }
    display: flex;
    align-items: center;
    justify-content: center;
`
